import { appInsights } from "../App/track";
import { useEffect } from 'react';
import { Box, Button, Heading, Text } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorFallback = _ref => {
  let {
    error
  } = _ref;
  const isString = typeof error === 'string';
  const isError = error instanceof Error;
  useEffect(() => {
    if (isString || isError) {
      appInsights.trackException({
        exception: isError ? error : new Error(error)
      });
    }
  }, [error]);
  return /*#__PURE__*/_jsxs(Box, {
    $backgroundColor: "--white",
    $borderRadius: "20u",
    $m: "100u auto",
    $maxWidth: "600u",
    $p: "5sp",
    "data-sentry-element": "Box",
    "data-sentry-component": "ErrorFallback",
    "data-sentry-source-file": "ErrorFallback.tsx",
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h1",
      level: 3,
      "data-sentry-element": "Heading",
      "data-sentry-source-file": "ErrorFallback.tsx",
      "data-sentry-element": "Heading",
      children: "Something went wrong"
    }), /*#__PURE__*/_jsx(Text, {
      $mb: "2sp",
      "data-sentry-element": "Text",
      "data-sentry-source-file": "ErrorFallback.tsx",
      "data-sentry-element": "Text",
      children: "An unexpected error occurred"
    }), (isString || isError) && /*#__PURE__*/_jsxs(Text, {
      $mb: "2sp",
      as: "details",
      children: [/*#__PURE__*/_jsx("summary", {
        children: "Error details"
      }), /*#__PURE__*/_jsx("code", {
        children: isString ? error : error.message
      })]
    }), /*#__PURE__*/_jsx(Button, {
      as: "a",
      href: "/dashboard",
      variant: "primary",
      "data-sentry-element": "Button",
      "data-sentry-source-file": "ErrorFallback.tsx",
      "data-sentry-element": "Button",
      children: "Dashboard"
    })]
  });
};